import * as clientList from './clientList';
import * as clientItem from './clientItem';
import * as clientFilesList from './clientFilesList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    clientList: clientList.IState
    clientItem: clientItem.IState
    clientFilesList: clientFilesList.IState
}

export const ActionCreators = {
    clientList: clientList.ActionCreators,
    clientItem: clientItem.ActionCreators,
    clientFilesList: clientFilesList.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    clientList: clientList.Reducers,
    clientItem: clientItem.Reducers,
    clientFilesList: clientFilesList.Reducers,
});

export function* sagas() {
    yield all([
        fork(clientList.sagas),
        fork(clientItem.sagas),
        fork(clientFilesList.sagas),
    ]);
}

